import React from "react";
import "./Header.scss";
import logo from "../img/LOGO2.png";
import fit from "../img/loga/LogoFit.png";
const Header = () => {
	return (
		<header className="hero-img">
			<div className="promo-banner">
				<p className="promo-text">
					-7% z hasłem: <strong>studio_BCR</strong>
				</p>
				<img
					src={fit} // podmień na własną ścieżkę
					alt="FitLife Catering Dietetyczny"
					className="promo-logo"
				/>
			</div>
				<div className="hero-text">
					<img src={logo} alt="Logo firmy" className="company-logo" />
					<p className="subtext">
						Twoje miejsce na mapie zdrowia i fitnessu. Zapraszamy do naszego
						studia treningowego!
					</p>
				</div>
				<div className="hero-shadow"></div>
			
		</header>
	);
};

export default Header;
